/**
 * Yields to the main thread so the browser can process pending user input,
 * paint, and other high-priority work before continuing.
 *
 * Uses `scheduler.yield()` (Chrome 129+) when available, falls back to
 * `setTimeout(0)` which defers to the next macrotask.
 *
 * @remarks Client-only — all callers must run in browser context.
 */
export function yieldToMain(): Promise<void> {
  if (globalThis.scheduler?.yield) {
    return globalThis.scheduler.yield()
  }
  return new Promise((resolve) => setTimeout(resolve, 0))
}
